import { render, staticRenderFns } from "./ComplaintDrug.vue?vue&type=template&id=7812989a&scoped=true"
import script from "./ComplaintDrug.vue?vue&type=script&lang=js"
export * from "./ComplaintDrug.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDrug.vue?vue&type=style&index=0&id=7812989a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7812989a",
  null
  
)

export default component.exports